import React, { useState, useEffect } from 'react';
import { formatISO } from 'date-fns';
import { ValueType } from 'rsuite/lib/DateRangePicker';
import { toast } from 'react-toastify';
import api from '../../services/api';
import { ReactComponent as Dots } from '../../icons/3dots-icon.svg';
import TableWControllers from '../../components/tableWControllers';
import RedePopUp from '../../components/PDVPopUps/Redes';
import { Container } from './styles';
import Filter from '../../components/PDVfilter';
import { useError } from '../../hooks/errors';

export default function Redes() {
  const [data, setData] = useState();
  const [openEdit, setOpenEdit] = useState(false);
  const [addRowData, setAddRowData] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [filteredData, setFilteredData] = useState();
  const [isFiltering, setIsFiltering] = useState<ValueType>();
  const { emitError } = useError();

  const handleFilter = async (e: ValueType) => {
    setIsFiltering(e);
    if (!e) return;
    try {
      const { data: response } = await api.get('/networks', {
        params: {
          startAt: formatISO(e[0]),
          endAt: formatISO(new Date(formatISO(e[1])).setHours(23, 59, 59)),
        },
      });

      setFilteredData(response);
    } catch (error) {
      emitError(error);
    }
  };

  useEffect(() => {
    api
      .get('/networks')
      .then((res: any) => setData(res.data))
      .catch(error => {
        emitError(error);
      });
  }, []);

  const [addRede, setAddRede] = useState(false);

  const columnRede = [{ title: 'Nome Rede', field: 'name' }];

  return (
    <Container>
      <TableWControllers
        importLink="network"
        importModelLink="https://pdv-general-mills.s3.sa-east-1.amazonaws.com/67fce21ec66f1989d94ccb9b52d7b3a4-Redes.xlsx"
        addButtonText="Adicionar Rede"
        filter
        filterState={openFilter}
        setFilter={setOpenFilter}
        title="Rede"
        isFiltering={!!isFiltering}
        column={[
          ...columnRede,

          {
            width: '10%',
            cellStyle: {
              textAlign: 'right',
            },

            render: (rowData: any) => (
              <button
                type="button"
                onClick={() => {
                  setAddRowData(rowData);
                  setOpenEdit(true);
                }}
              >
                <Dots />
              </button>
            ),
          },
        ]}
        data={isFiltering ? filteredData : data}
        addButtonState={addRede}
        addButtonFunction={setAddRede}
      />
      {addRede ? (
        <RedePopUp isOpen={addRede} setPopUpState={setAddRede} />
      ) : null}

      {openEdit ? (
        <RedePopUp
          isOpen={openEdit}
          setPopUpState={setOpenEdit}
          rowData={addRowData}
        />
      ) : null}

      {openFilter ? (
        <Filter
          isOpen={openFilter}
          setPopUpState={setOpenFilter}
          handleChange={handleFilter}
          handleClearFilters={setIsFiltering}
          date={isFiltering}
        />
      ) : null}
    </Container>
  );
}
